<!--
 * @Description: 单因素与多样本比较
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div class="bi-tmpl-detail__right__cmpt__tips">
      {{ curItem.tips }}
    </div>
    <div>
      <div class="bi-tmpl-detail__right__cmpt__tips" style="margin-top: 0">
        请选择表格样式
      </div>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING1"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w table"
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            <component
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
                white-space: wrap;
              "
              :is="cmpName(item.moduleType, PcModulePercent)"
              v-bind="{
                tableHeaderList: multiSample[0].table.header,
                tableDataList: multiSample[0].table.value
              }"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div>
      <div class="bi-tmpl-detail__right__cmpt__tips">请选择图表样式</div>
    </div>
    <Carousel ref="carouselRef" :itemHeight="515" :itemWidth="420 + 56">
      <div
        style="height: 500px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING2"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 500px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w table2"
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            <component
              :is="cmpName(item.moduleType, PcModuleBigTable)"
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
                white-space: wrap;
              "
              v-bind="{
                tableHeaderList: multiSample[0].extTable.header,
                tableDataList: multiSample[0].extTable.value
              }"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div
      style="
        padding: 10px 24px;
        font-size: 14px;
        border: 1px solid #dbdbdb;
        margin-top: 20px;
        color: #484848;
      "
    >
      <span>
        {{ multiSample[0].extTable.summary }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio, BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModulePercent from '../bi-pc-module/pc-module-table/index';
import PcModuleBigTable from '../bi-pc-module/pc-module-complex-table/index';
import { multiSample } from '../../mock/_multi-sample';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const TYPE_MAPPING1 = PcModulePercent.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const TYPE_MAPPING2 = PcModuleBigTable.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-complex-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const cmpName = (name, modules) => {
  return modules.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({});
</script>
<style lang="scss" scoped>
::v-deep .table {
  .xrk-radio__input {
    bottom: -90px !important;
  }
}
::v-deep .table2 {
  .xrk-radio__input {
    bottom: -382px !important;
  }
}
</style>
